import { useFeatureQuery } from '@common/hooks/query/useFeatureQuery';
import {
    BaseFeatureArgs,
    FixedFilterGenerator,
    InitialQueryState,
    SkipOrArgs,
} from '@common/types/queryState';
import { useSelectedAccountId } from '@features/accounts';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetProductionsQuery } from '../api';
import { GetProductionsArgs } from '../types';

const productionsFilterGenerator: FixedFilterGenerator<
    BaseFeatureArgs & { accountId: string }
> = (args) => {
    return ['-type:DELIVERY', `accountId:${args.accountId}`];
};

export const useProductions = (initialArgs: InitialQueryState = {}) => {
    const accountId = useSelectedAccountId();

    const queryArgs: SkipOrArgs<GetProductionsArgs> = useMemo(() => {
        if (!accountId) return skipToken;

        return {
            accountId,
            fixedFilterGenerators: [productionsFilterGenerator],
        } as GetProductionsArgs;
    }, [accountId]);

    return useFeatureQuery(initialArgs, useGetProductionsQuery, queryArgs);
};
